<section class="flex">
  <h3 class="flex flex-grow items-start">
    <span>Views</span>
  </h3>

  <div class="flex flex-row-reverse -mt-2 cursor-pointer close-btn-border justify-center items-center" (click)="closeDialog()">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" class="x-button" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.75 16.25L16.25 3.75" [attr.stroke]="'#B3AFBB'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M3.75 3.75L16.25 16.25" [attr.stroke]="'#B3AFBB'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>
</section>

<div class="flex flex-start flex-col mt-6 mb-6" *ngIf="views$ | async as views">
  <ng-container *ngIf="views && views.length > 0; else noData">
    <div class="flex flex-row w-full" *ngFor="let view of views">
      <div class="flex align-middle flex-grow">
        <div (click)="$event.stopPropagation()">
          <div class="filters__select-columns vertical-align-middle">
            <mat-radio-group (click)="onChangeActiveViewUUID(view.uuid)" class="filters__date-menu">
              <mat-radio-button [checked]="uuid ? view.uuid === uuid : view.uuid === (activeView$ | async)?.uuid" [value]="view.uuid">
                {{ view.name }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div class="flex flex-row-reverse align-middle items-center">
        <button mat-flat-button class="button__small button__text !text-red-dark" (click)="deleteView(view)">
          <ng-container *ngIf="(loadingState$ | async) === LoadingState.Pending && deletingViewUUID === view.uuid">
            <hospitable-loading [size]="LoadingSize.Small"></hospitable-loading>
          </ng-container>
          <ng-container *ngIf="(loadingState$ | async) !== LoadingState.Pending"> Delete </ng-container>
        </button>

        <button *ngIf="view.publicly_available" mat-flat-button class="button__small button__text !text-gray" (click)="updateView(view, false)">
          <ng-container *ngIf="(loadingState$ | async) === LoadingState.Pending && updatedViewUUID === view.uuid">
            <hospitable-loading [size]="LoadingSize.Small"></hospitable-loading>
          </ng-container>
          <ng-container *ngIf="(loadingState$ | async) !== LoadingState.Pending"> Revoke link </ng-container>
        </button>

        <button
          *ngIf="view.publicly_available && view.public_link"
          mat-flat-button
          class="button__small button__text !text-gray"
          ngxClipboard
          [cbContent]="view.public_link"
          (click)="copiedToClipboard()"
        >
          Copy link
        </button>

        <button *ngIf="!view.publicly_available" mat-flat-button class="button__small button__text !text-green-dark" (click)="updateView(view, true)">
          <ng-container *ngIf="(loadingState$ | async) === LoadingState.Pending && updatedViewUUID === view.uuid">
            <hospitable-loading [size]="LoadingSize.Small"></hospitable-loading>
          </ng-container>
          <ng-container *ngIf="(loadingState$ | async) !== LoadingState.Pending"> Create link </ng-container>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #noData>
    <div class="flex items-center justify-center mt-8">
      <hospitable-page-level-error [message]="'No views found'"> </hospitable-page-level-error>
    </div>
  </ng-template>
</div>

<div class="flex flex-row">
  <div class="flex grow"></div>
  <div class="flex">
    <button [disabled]="!uuid" mat-flat-button (click)="applyView()" class="button__small">Apply</button>
  </div>
  
</div>
